import { Entity } from 'mk2/schemas';
import { schema } from 'normalizr';

export interface TwoDimsVariant {
    width: number;
    depth: number;
    variant: string;
}

export interface Features {
    adjustable_handle: boolean;
    all_wheels_are_double: boolean;
    artificial_wheel_type: string[];
    autolock: boolean;
    back_support_can_be_extended: boolean;
    back_support_can_be_in_lying_position: boolean;
    back_support_can_be_positioned: boolean;
    back_support_length_in_cm_max: number;
    back_support_length_in_cm_min: number;
    back_support_positioning_type: string[];
    back_support_positions_l: number[];
    big_shopping_basket: boolean;
    bucket_seat: boolean;
    bucket_second_seat: boolean;
    builtin_speaker: boolean;
    bumper_bar: boolean;
    bumper_bar_can_be_positioned: boolean;
    bumper_bar_can_be_removed: boolean;
    bumper_bar_type: string[];
    can_be_converted_to_a_double: boolean;
    can_be_converted_to_a_single: boolean;
    can_be_pulled_behind: boolean;
    car_seat_can_be_attached: string[];
    car_seat_compatibility_most_brands: boolean;
    car_seat_compatibility_roemer: boolean;
    car_seat_has_to_be_bought: string;
    carrycot_dims_in_cm: TwoDimsVariant[];
    carrycot_has_handle: string[];
    carrycot_has_ventilation: string[];
    carrycot_usable_in_car: string[];
    carrycot_with_cradle: string[];
    carrycot_can_be_attached: string[];
    central_brake_present: boolean;
    central_brake_system: string[];
    checked_baggage: boolean;
    combo_only: boolean;
    cupholder_possibility: boolean;
    discontinued: boolean;
    discontinued_year: number;
    extendable_hood: boolean;
    foldable_carrycot: string[];
    folded_dimensions_in_cm_height_max: number;
    folded_dimensions_in_cm_height_min: number;
    folded_dimensions_in_cm_length_max: number;
    folded_dimensions_in_cm_length_min: number;
    folded_dimensions_in_cm_width_max: number;
    folded_dimensions_in_cm_width_min: number;
    folding_system: string[];
    folds_by_itself: boolean;
    folds_with_the_seat_attached: boolean;
    folds_with_the_seat_in_reverse: boolean;
    foot_rest: boolean;
    front_wheel_type: string[];
    front_wheels_diameter_in_cm_l: number[];
    fully_fledged_second_seat: boolean;
    handle_height_in_cm_max: number;
    handle_height_in_cm_min: number;
    handle_material: string[];
    has_carry_handle: boolean;
    height_adjustable_seat: boolean;
    higher_seat_position: boolean;
    hood_features_a_sun_visor: boolean;
    inclinable_carrycot: string[];
    led_lighting: boolean;
    leg_rest_can_be_extended: boolean;
    leg_rest_can_be_positioned: boolean;
    leg_rest_positions: number;
    manual_brake_present: boolean;
    maximum_load_per_1st_child_in_kg: number;
    maximum_load_per_2nd_child_in_kg: number;
    maximum_load_per_child_in_kg: number;
    memory_button: boolean;
    missing_sitting_part: boolean;
    model_url: string;
    motorized: boolean;
    number_of_double_wheels: number;
    number_of_wheels_l: number[];
    one_hand_folding: boolean;
    one_hand_positioning: boolean;
    origin_countries: string[];
    parent_tray_organizer: boolean;
    platform_material: string[];
    possibility_of_terrain_wheels: boolean;
    pramette_seat_2in1: boolean;
    rear_wheel_type: string[];
    rear_wheels_diameter_in_cm_l: number[];
    recommended_age_max: number;
    recommended_age_min: number;
    retroreflector: boolean;
    roof_present: boolean;
    rotating_seat: boolean;
    rotating_second_seat: boolean;
    rotating_wheels: boolean;
    seat_dims_in_cm_depth: number;
    seat_dims_in_cm_width: number;
    seat_fabrics_can_be_taken_off: boolean;
    seat_safety_indicator: boolean;
    seat_surface_total_length_in_cm_max: number;
    seat_surface_total_length_in_cm_min: number;
    second_seat_back_support_can_be_in_lying_position: boolean;
    second_seat_back_support_can_be_positioned: boolean;
    second_seat_back_support_length_in_cm_max: number;
    second_seat_back_support_length_in_cm_min: number;
    second_seat_back_support_positioning_type: string[];
    second_seat_back_support_positions_l: number[];
    second_seat_bumper_bar: boolean;
    second_seat_dims_in_cm_depth: number;
    second_seat_dims_in_cm_width: number;
    second_seat_foot_rest: boolean;
    second_seat_leg_rest: boolean;
    second_seat_one_hand_positioning: boolean;
    second_seat_recommended_age_max: number;
    second_seat_recommended_age_min: number;
    second_seat_roof_present: boolean;
    second_seat_surface_total_length_in_cm_max: number;
    second_seat_surface_total_length_in_cm_min: number;
    shopping_basket: boolean;
    shopping_basket_capacity_in_kg: boolean;
    shopping_basket_closable: boolean;
    sportgolf_only: boolean;
    standing_fold: boolean;
    supplied_cape: boolean;
    supplied_changing_bag: string;
    supplied_footmuff: boolean;
    supplied_mosquito_net: boolean;
    supplied_pad: boolean;
    supplied_transport_bag: boolean;
    supplied_wheel_protective_sleeves: boolean;
    suspended_wheels: string;
    suspension: boolean;
    suspension_type: string[];
    swing_away_bumper_bar: boolean;
    swinging: boolean;
    two_car_seats_can_be_attached: boolean;
    type: string[];
    type_of_handle_adjustment: string[];
    unfolded_dimensions_in_cm_height_max: number;
    unfolded_dimensions_in_cm_height_min: number;
    unfolded_dimensions_in_cm_length_max: number;
    unfolded_dimensions_in_cm_length_min: number;
    unfolded_dimensions_in_cm_width_max: number;
    unfolded_dimensions_in_cm_width_min: number;
    video_url: object[];
    weight_in_kg_max: number;
    weight_in_kg_min: number;
    wheel_direction_memory: boolean;
    wheel_mudguards: boolean;
    wheels_can_be_arrested: boolean;
    wheels_can_be_removed: boolean;
    wipe_clean_leg_rest: boolean;
}

export interface UserReviewMinEntity extends Entity {
    username: string;
    isRegisteredUser: boolean;
    strollerSlug: string;
    score: number;
    oneliner: string;
    perex: string;
    detailedReview: boolean;
    showDetailLink: boolean;
}

interface UserReviewDetailEntity {
    createdTime: string;
    text: string;
    positives?: string[];
    negatives?: string[];
}

export interface UserReviewEntity extends UserReviewMinEntity {
    detail?: UserReviewDetailEntity;
}

export const UserReviewDetailSchema = new schema.Entity('strollerUserReviewDetails', {
}, {
    idAttribute: (value, parent, key) => value.id || parent.id,
    processStrategy: (value, parent, key) => ({ ...value, id: parent.id }),
});

export const MinUserReviewSchema = new schema.Entity('strollerUserReviews', {
});

export const UserReviewSchema = new schema.Entity('strollerUserReviews', {
    detail: UserReviewDetailSchema,
});

export interface QuestionEntity extends Entity {
    question: string;
    answer: string;
}

export interface SiblingSlugs {
    201?: string;
    202?: string;
    207?: string;
}

export interface StrollerMinEntity extends Entity {
    name: string;
    slug: string;
    siblingSlugs: SiblingSlugs;
    prepared: boolean;
    ourScore: number;
    userScore: number;
    firstPhoto: StrollerPhoto;
}

interface StrollerDetailEntity {
    brandSlug: string;
    description?: string;
    otherPhotos: StrollerPhoto[];
    numUserReviews: number;
    features?: Features;
    hotUserReviews?: UserReviewEntity[];
    questions?: QuestionEntity[];
    similar: StrollerEntity[];
    hasAllReviews: boolean;
    hasAllSimilar: boolean;
}

interface StrollerUserReviewsListEntity {
    otherUserReviews: UserReviewEntity[];
}

export interface StrollerEntity extends StrollerMinEntity {
    detail?: StrollerDetailEntity;
    userReviews?: StrollerUserReviewsListEntity;
}

export interface StrollerPhoto {
    originalWidth: number;
    originalHeight: number;
    url100x100: string;
    url250x250: string;
}

export interface MinBrandEntity extends Entity {
    name: string;
    slug: string;
}

export interface BrandEntity extends MinBrandEntity {
    description: string;
    brandUrl: string;
    logoPhoto: StrollerPhoto;
    strollerPhoto: StrollerPhoto;
    numStrollers: number;
    numPreparedStrollers: number;
}

export interface CountryEntity extends Entity {
    msgid: string;
    name: string;
}

export const MinStrollerSchema = new schema.Entity('strollers', {
});

export const StrollerDetailSchema = new schema.Entity('strollerDetails', {
    userReviews: [UserReviewSchema],
    similar: [MinStrollerSchema],
}, {
    idAttribute: (value, parent, key) => value.id || parent.id,
    processStrategy: (value, parent, key) => ({ ...value, id: parent.id }),
});

export const StrollerSchema = new schema.Entity('strollers', {
    detail: StrollerDetailSchema,
});

export const StrollerReviewSchema = {
    stroller: StrollerSchema,
    fullUserReview: UserReviewSchema,
};

export const StrollerBrandSchema = new schema.Entity('strollerBrands', {
});

export const strollerBrandsSchema = {
    strollerbrands: [StrollerBrandSchema],
};
